module.exports = __webpack_public_path__ + "static/img/login-banner-enterprise.dcc6dc06.png";